



























import { Vue, Component, Inject, Prop, Ref } from "vue-property-decorator";
import FastInMain from "./FastInMain.vue";
@Component({
  name: "FastIn",
  components: { FastInMain }
})
export default class FastIn extends Vue {
  private style: any = {};

  private visible: boolean = false;

  @Ref("main")
  private main!: FastInMain;

  @Inject({ from: "client", default: "web" })
  private client!: "web" | "mobile";

  @Prop({ required: true })
  private options!: {
    template: string;
    widgets: App.WebForm.Widget[];
    width: number | string;
    group: Array<App.WebForm.DataGroup>;
  };

  onListItemChange(index: number) {
    const item = this.options.group[index];
    this.main.show(item);
  }

  fastInSingle() {
    this.main.show(this.options.group[0]);
  }

  init() {
    if (this.client === "web") {
      let ctr = document.querySelector(
        ".wbench-form-container"
      ) as HTMLDivElement;
      if (!ctr) return;
      const header = ctr.querySelector(
        ".left-box .el-tabs__header"
      ) as HTMLDivElement;

      if (!header) return;

      const mrect = header.getBoundingClientRect();
      const style = {
        left: mrect.left + mrect.width - 100 - 20 + "px",
        top: mrect.top + (mrect.height - 30) / 2 + "px"
      };

      this.style = style;
    } else {
      this.style = {
        bottom: "50px",
        right: "50px"
      };
    }
    this.visible = true;
  }

  mounted() {
    setTimeout(() => {
      this.init();
    }, 500);
  }
}
